<div class="header" [attr.data-testid]="ELEMENT_IDS['header']">
  <button mat-icon-button routerLink="/" [attr.data-testid]="ELEMENT_IDS['btn_back']">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <h5 [attr.data-testid]="ELEMENT_IDS['lbl_title']">Privacy Policy</h5>
</div>
<mat-tab-group [attr.data-testid]="ELEMENT_IDS['page']">
    <mat-tab label="Terms and Conditions" [aria-label]="ELEMENT_IDS['tab_terms_and_conditions']">
        <div class="tab-container" [attr.data-testid]="ELEMENT_IDS['cnt_terms_and_conditions']">
            @for (datum of data?.tncData; track $index) {
            <div class="section">
                <div [attr.data-testid]="'section_tnc_title_' + generateAutomationId(datum?.rawTitle)" class="section-title" [innerHTML]="datum?.title"></div>
                <div [attr.data-testid]="'section_tnc_description_' + generateAutomationId(datum?.rawTitle)" class="section-detail" [innerHTML]="datum?.description"></div>
            </div>
            }
        </div>
    </mat-tab>
    <mat-tab label="Privacy Policy" [aria-label]="ELEMENT_IDS['tab_privacy_policy']">
        <div class="tab-container" [attr.data-testid]="ELEMENT_IDS['cnt_privacy_policy']">
            @for (datum of data?.ppData; track $index) {
            <div class="section">
                <div [attr.data-testid]="'section_pp_title_' + generateAutomationId(datum?.rawTitle)" class="section-title" [innerHTML]="datum?.title"></div>
                <div [attr.data-testid]="'section_pp_description_' + generateAutomationId(datum?.rawTitle)" class="section-detail" [innerHTML]="datum?.description"></div>
            </div>
            }
        </div>
    </mat-tab>
</mat-tab-group>
